import styled from "styled-components";
import { Mouse } from "@styled-icons/boxicons-regular";
import texture from "assets/images/texture-home.jpg";
import photo1 from "assets/images/Xô-boi-abre-semtextura.jpg";

import { fonts } from "styles";

export const Container = styled.section`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100vh;
  display: flex;
  background-size: cover;
  position: relative;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 1010px) {
    flex-direction: column-reverse;
    height: auto;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.left {
    max-width: 55%;
    padding: 56px 41px;
    background: url(${texture}) repeat center center;
  }

  &.right {
    min-width: 45%;
    /* background-size: contain; */
  }

  @media screen and (max-width: 1010px) {
    &.left {
      max-width: 100%;
      padding: 56px 41px 0 41px;
      background: unset;
    }

    &.right {
      max-width: 100%;
      align-items: flex-start;
    }
  }
`;

export const PhotoWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const Photo1 = styled.img.attrs({ src: photo1 })`
  width: auto;
  height: 100%;
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const PhotoLegend = styled.span`
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 22px;
  color: black;
  display: block;
  position: absolute;
  bottom: 32px;
  left: -38px;
  writing-mode: vertical-rl;
  transform: rotate(180deg);

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;

export const PhotoLegendMobile = styled.span`
  font-family: ${fonts.BentonSansRegular};
  font-size: 12px;
  line-height: 22px;
  color: black;
  margin-top: 16px;
  display: none;
  padding: 0 41px;

  @media screen and (max-width: 1010px) {
    display: block;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 394px;

  @media screen and (max-width: 1010px) {
    padding: 0 10px;
    border-bottom: 1px solid #707070;
  }
`;

export const SubTitle = styled.h2`
  font-family: ${fonts.BentonSansWideRegular};
  font-size: 25px;
  line-height: 25px;
  letter-spacing: -1px;
  text-transform: uppercase;
  color: black;

  @media screen and (max-width: 414px) {
    font-size: 16px;
    line-height: 12px;
    margin-bottom: 6px;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 76px;
  line-height: 76px;
  letter-spacing: -1px;
  margin-bottom: 32px;
  text-transform: uppercase;
  color: black;

  @media screen and (max-width: 414px) {
    font-size: 38px;
    line-height: 38px;
    margin-bottom: 24px;
  }
`;

export const Text = styled.article`
  width: 100%;
  font-size: 18px;
  line-height: 24px;
  color: black;
  margin-bottom: 32px;

  @media screen and (max-width: 414px) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 24px;
  }
`;

export const ScrollInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 22px;
  font-family: ${fonts.BentonSansMedium};
  color: black;
  text-transform: uppercase;
  pointer-events: none;

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;

export const IconChevron = styled(Mouse).attrs({ size: 24 })`
  color: #05a2a9;
  margin-right: 8px;
  transition: 300ms;
  animation-name: jump;
  animation-duration: 700ms;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-fill-mode: both;
  animation-iteration-count: infinite;

  @keyframes jump {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-5px);
    }
  }
`;

export const Credit = styled.span`
  display: block;
  font-family: ${fonts.BentonSansMedium};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 3px;
  color: black;
  text-transform: uppercase;
  margin-bottom: 60px;

  @media screen and (max-width: 414px) {
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 40px;
  }
`;
